/** Request to create a copy of an existing work order. */
export default class CopyWorkOrderRequest {
    /** Id of the work order to copy. */
    public sourceWorkOrderId = "";
}